
















import { Prop, Ref, Component, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'

export enum PopupAlign {
    left = 'left',
    right = 'right',
}

export enum PopupValign {
    top = 'top',
    bottom = 'bottom',
}

@Component
export default class Popup extends Vue {
    @Prop({ default: PopupAlign.left }) readonly align!: PopupAlign
    @Prop({ default: PopupValign.top }) readonly valign!: PopupValign
    @Ref() wrapper: HTMLDivElement
    @Prop({ default: () => ({})}) wrapperStyle: object
    visible: boolean = false

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(this.wrapper, {
            opacity: 0,
        })

        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 1,
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 0,
            onComplete,
        })
    }

    get wrapperClass() {
        return [
            'popup__wrapper--' + this.align,
            'popup__wrapper--' + this.valign,
        ]
    }
}

